<script setup lang="ts">
import { useMatchmakingDataStore } from '~/stores/matchmaking'
import FilterSetting from '~/components/data-filters/FilterSetting.vue'
import MatchmakingList from '~/components/region-statistics/MatchmakingList.vue'
const matchmakingStore = useMatchmakingDataStore()

const filterSettings = computed(() => matchmakingStore.filterSettings)
</script>
<template>
  <FilterSetting
    content-type="matchmaking"
    select-type="multiple"
    :setting="filterSettings.fuelTypes"
    class="my-4 sm:mr-4"
  />
  <FilterSetting
    content-type="matchmaking"
    :setting="filterSettings.type"
    select-type="multipleSelect"
    class="my-4 sm:mr-4"
  />
  <Divider />

  <MatchmakingList />
</template>
